import { Component, forwardRef, Input, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-custom-radio',
    imports: [],
    templateUrl: './custom-radio.component.html',
    styleUrls: ['./custom-radio.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomRadioComponent),
            multi: true,
        },
    ],
})
export class CustomRadioComponent implements ControlValueAccessor {
    @Input() options: { value: string | boolean; label: string }[] = [];
    // writeValue is driven by the forms API, so this has to notify on its own.
    value = signal<any>(undefined);
    onChange: any = () => {};
    onTouched: any = () => {};

    writeValue(value: any): void {
        this.value.set(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // You can implement this method if you want to support disabling the radio button
    }

    selectOption(option: any) {
        this.value.set(option);
        this.onChange(option);
        this.onTouched();
    }
}
